import React, { useEffect,  useState } from "react";

import { Row, Col } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import { useSelector } from "react-redux";
import FASTable from "../../../../../components/Tables/FASTable";

import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Multi_Year({ accountName, accountGroup }) {

  const [activeYear, setActiveYear] = useState(null);
  const [yearlyData, setYearlyData] = useState({});
  const [years, setYears] = useState([]);


  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { LedgerMultiYeardata } = useSelector((state) => state.LedgerSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const formatDateToDDMMYYYY = (isoString) => {
    if (!isoString) return "";
    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "";
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatIndianAmount = (value) => {
    if (!value) return "0.00";

    const str = String(value).trim();

    // Number extract
    const numberMatch = str.match(/-?\d+(\.\d+)?/);

    if (!numberMatch) return value;

    const num = Number(numberMatch[0]);

    // Cr / Dr extract
    const typeMatch = str.match(/\b(Cr|Dr)\b/i);
    const type = typeMatch ? typeMatch[0] : "";

    const formattedNumber = num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${formattedNumber} ${type}`.trim();
  };

  useEffect(() => {
    if (LedgerMultiYeardata?.LedgerMultiYear) {
      const grouped = {};
      const apiYears = [];

      LedgerMultiYeardata.LedgerMultiYear.forEach((item, index) => {
        if (!item.VouDate || !item.FAcYear) return;
        const yearLabel = item.FAcYear;

        if (!grouped[yearLabel]) {
          grouped[yearLabel] = [];
          apiYears.push(yearLabel);
        }

        grouped[yearLabel].push({
          // srNumber: index + 1,
          VouDate: formatDateToDDMMYYYY(item.VouDate),
          VouNo: item.VouNo,
          ChqNo: item.ChqNo,
          Description: item.Description,
          Debit: item.Debit,
          Credit: item.Credit,
          Balance: item.Balance,
          AmtType: item.AmtType,
        });
      });

      setYearlyData(grouped);
      setYears(apiYears);

      if (apiYears.length > 0) {
        setActiveYear("ALL");
      }
    }
  }, [LedgerMultiYeardata]);

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Date", key: "VouDate", align: "center" },
    { label: "Vou No", key: "VouNo", align: "right" },
    { label: "Chq No", key: "ChqNo", align: "right" },
    { label: "Description", key: "Description", align: "left" },
    { label: "Debit", key: "Debit", align: "right", format: true },
    { label: "Credit", key: "Credit", align: "right", format: true },
    { label: "Balance", key: "Balance", align: "right", format: true },
    { label: "Bal Type", key: "AmtType", align: "right" },
  ];

  const accountDetail = LedgerMultiYeardata?.AccountDetail?.[0] || {};
  const openingData = LedgerMultiYeardata?.FAcOpening || [];
  const balanceData = LedgerMultiYeardata?.FAcBalance || [];

  const getOpeningForYear = (yearLabel) => {
    if (!yearLabel || openingData.length === 0) return "0.00";
    const match = openingData.find((o) => o.FAcYear === yearLabel);
    return match ? match.OpAmount : "0.00";
  };

  const getBalanceForYear = (yearLabel) => {
    if (!yearLabel || balanceData.length === 0) return "0.00";
    const match = balanceData.find((b) => b.FAcYear === yearLabel);
    return match ? match.Balance : "0.00";
  };

  const selectedOpening = getOpeningForYear(activeYear);
  const selectedBalance = getBalanceForYear(activeYear);

  const getAllYearData = () => {
    let allData = [];
    Object.values(yearlyData).forEach((yearArr) => {
      allData = [...allData, ...yearArr];
    });
    return allData;
  };

  const getFinancialMonthOrder = (dateStr) => {
    if (!dateStr) return 0;

    const parts = dateStr.split("/");
    if (parts.length !== 3) return 0;

    const month = parseInt(parts[1], 10);

    // April se FY start
    return month >= 4 ? month : month + 12;
  };

  const rawTableData =
    activeYear === "ALL" ? getAllYearData() : yearlyData?.[activeYear] || [];

  const tableData = [...rawTableData].sort((a, b) => {
    return (
      getFinancialMonthOrder(a.VouDate) - getFinancialMonthOrder(b.VouDate)
    );
  });

  const yearWiseTotal = LedgerMultiYeardata?.LedgerSumm?.find(
    (item) => item.FAcYear === activeYear,
  );
  const externalTotals = {
    Debit: yearWiseTotal?.Debit || 0,
    Credit: yearWiseTotal?.Credit || 0,
    Balance: yearWiseTotal?.Balance || 0,
  };

  // const handleDownload = () => {
  //   const doc = new jsPDF({
  //     orientation: "landscape",
  //     unit: "mm",
  //     format: "a4",
  //   });
  //   const formatIndianNumber = (value) => {
  //     const num = Number(value || 0);

  //     return num.toLocaleString("en-IN", {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     });
  //   };

  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const marginX = 14;
  //   let yPos = 15;

  //   // ================= TITLE =================
  //   doc.setFontSize(14);
  //   doc.setFont("helvetica", "bold");

  //   doc.text("Ledger Multi-Year Report", pageWidth / 2, yPos, {
  //     align: "center",
  //   });

  //   yPos += 5;

  //   doc.setLineWidth(0.5);
  //   doc.line(marginX, yPos, pageWidth - marginX, yPos);

  //   // ================= FIRM NAME =================
  //   const firmName =
  //     DataMain?.Firm_Dtl?.[0]?.FirmName ||
  //     DataMain?.Firm_List?.[0]?.GroupName ||
  //     "";

  //   yPos += 7;

  //   doc.setFontSize(12);
  //   doc.setFont("helvetica", "bold");

  //   doc.text(firmName, pageWidth / 2, yPos, {
  //     align: "center",
  //   });

  //   yPos += 10;

  //   // ================= ACCOUNT DETAILS =================
  //   doc.setFontSize(11);
  //   doc.setFont("helvetica", "normal");

  //   const account = LedgerMultiYeardata?.AccountDetail?.[0] || {};

  //   doc.text(`A/c Name : ${account.AcName || "-"}`, marginX, yPos);
  //   yPos += 6;
  //   doc.text(`Pan No   : ${account.PanNo || "-"}`, marginX, yPos);
  //   yPos += 6;
  //   doc.text(`City     : ${account.CityName || "-"}`, marginX, yPos);
  //   yPos += 6;
  //   doc.text(`Address  : ${account.Address || "-"}`, marginX, yPos);

  //   yPos += 6;
  //   doc.line(marginX, yPos, pageWidth - marginX, yPos);
  //   yPos += 10;

  //   // ================= YEAR LOOP =================
  //   years.forEach((year) => {
  //     const opening = formatIndianAmount(getOpeningForYear(year) || 0);

  //     const tableRows = (yearlyData[year] || []).map((row, i) => [
  //       i + 1,
  //       row.VouDate,
  //       row.VouNo,
  //       row.ChqNo,
  //       row.Description,
  //       formatIndianNumber(row.Debit),
  //       formatIndianNumber(row.Credit),
  //       row.AmtType || "-",
  //     ]);

  //     const totalDebit = (yearlyData[year] || [])
  //       .reduce((sum, r) => sum + Number(r.Debit || 0), 0)
  //       .toFixed(2);

  //     const totalCredit = (yearlyData[year] || [])
  //       .reduce((sum, r) => sum + Number(r.Credit || 0), 0)
  //       .toFixed(2);

  //     // ================= PAGE BREAK SAFETY =================
  //     if (yPos > 160) {
  //       doc.addPage();
  //       yPos = 15;
  //     }

  //     // ================= YEAR HEADER =================
  //     doc.setFont("helvetica", "bold");
  //     doc.setFontSize(12);
  //     doc.text(`Year: ${year}`, marginX, yPos);

  //     const rightText = `Opening: ${opening}`;
  //     doc.setFont("helvetica", "normal");
  //     doc.text(
  //       rightText,
  //       pageWidth - marginX - doc.getTextWidth(rightText),
  //       yPos,
  //     );

  //     yPos += 6;

  //     const rightText2 = `Debit: ${totalDebit}  Credit: ${totalCredit}`;
  //     doc.text(
  //       rightText2,
  //       pageWidth - marginX - doc.getTextWidth(rightText2),
  //       yPos,
  //     );

  //     yPos += 5;

  //     // ================= TABLE =================
  //     autoTable(doc, {
  //       startY: yPos,

  //       head: [
  //         [
  //           "Sr",
  //           "Date",
  //           "Vou No",
  //           "Chq No",
  //           "Description",
  //           "Debit",
  //           "Credit",
  //           "Type",
  //         ],
  //       ],

  //       body: tableRows,

  //       // ✅ Total Row
  //       foot: [
  //         [
  //           "",
  //           "",
  //           "",
  //           "",
  //           "Total",
  //           formatIndianNumber(totalDebit),
  //           formatIndianNumber(totalCredit),
  //           "",
  //         ],
  //       ],

  //       theme: "grid",

  //       styles: {
  //         fontSize: 8,
  //         cellPadding: 2,
  //         valign: "middle",
  //         overflow: "linebreak",
  //       },

  //       headStyles: {
  //         fillColor: [230, 230, 230],
  //         textColor: 0,
  //         fontStyle: "bold",
  //         halign: "center",
  //       },

  //       // ✅ Footer Style
  //       footStyles: {
  //         fillColor: [245, 245, 245],
  //         textColor: 0,
  //         fontStyle: "bold",
  //       },

  //       columnStyles: {
  //         0: {
  //           halign: "center",
  //           cellWidth: 12,
  //         },
  //         1: {
  //           halign: "center",
  //           cellWidth: 22,
  //         },
  //         2: {
  //           halign: "center",
  //           cellWidth: 22,
  //         },
  //         3: {
  //           halign: "center",
  //           cellWidth: 22,
  //         },
  //         4: {
  //           halign: "left",
  //           cellWidth: 75, // description bigger
  //         },
  //         5: {
  //           halign: "right",
  //           cellWidth: 28,
  //         },
  //         6: {
  //           halign: "right",
  //           cellWidth: 28,
  //         },
  //         7: {
  //           halign: "center",
  //           cellWidth: 20,
  //         },
  //       },

  //       // ✅ Table center align
  //       tableWidth: "wrap",
  //       horizontalPageBreak: false,
  //       margin: {
  //         left: 12,
  //         right: 12,
  //       },

  //       didDrawPage: (data) => {
  //         yPos = data.cursor.y + 8;
  //       },
  //     });

  //     yPos += 8;
  //   });

  //   doc.save("Ledger_MultiYear_Report.pdf");
  // };

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    // ----------------- Title -----------------
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");

    // ✅ Title center
    doc.text("Ledger Multi-Year Report", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(14, 18, pageWidth - 14, 18);

    let yPos = 24; // ✅ upar ka extra gap remove

    // ----------------- Firm Name -----------------
    const firmName =
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      DataMain?.Firm_List?.[0]?.GroupName ||
      "";

    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);

    // ✅ Firm name center
    doc.text(firmName || "Firm Name", pageWidth / 2, yPos, { align: "center" });

    yPos += 8;
    // ----------------- Account Description -----------------
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.text(`A/c Name : ${accountDetail.AcName || ""}`, 14, yPos);
    yPos += 6;
    doc.text(`Pan No   : ${accountDetail.PanNo || ""}`, 14, yPos);
    yPos += 6;
    doc.text(`Address  : ${accountDetail.Address || ""}`, 14, yPos);
    yPos += 6;
    doc.text(`City     : ${accountDetail.CityName || ""}`, 14, yPos);

    yPos += 8;
    doc.line(14, yPos, 283, yPos);
    yPos += 10;

    years.forEach((year) => {
      const opening = getOpeningForYear(year);

      if (yPos > 180) {
        doc.addPage();
        yPos = 20;
      }

      const pageWidth = doc.internal.pageSize.getWidth();
      const rightMargin = 14;

      // ✅ Year heading (Left side)
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text(`Year: ${year}`, 14, yPos);

      // ✅ Opening (Right side)
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
      const formattedOpening = formatIndianAmount(opening);

      doc.text(
        `Opening: ${formattedOpening}`,
        pageWidth -
          rightMargin -
          doc.getTextWidth(`Opening: ${formattedOpening}`),
        yPos,
      );

      yPos += 7;

      // ----------------- Table Data -----------------
      const tableRows = (yearlyData[year] || []).map((row) => [
        row.srNumber,
        row.VouDate,
        row.VouNo,
        row.ChqNo,
        row.Description,
        formatIndianAmount(row.Debit), // ✅ Indian format
        formatIndianAmount(row.Credit), // ✅ Indian format
        row.AmtType,
      ]);

      const totalDebit = yearlyData[year].reduce(
        (sum, row) => sum + Number(row.Debit || 0),
        0,
      );

      const totalCredit = yearlyData[year].reduce(
        (sum, row) => sum + Number(row.Credit || 0),
        0,
      );
      tableRows.push([
        {
          content: "Year Total",
          colSpan: 5,
          styles: {
            halign: "right",
            fontStyle: "bold",
            fillColor: [220, 220, 220],
          },
        },
        {
          content: formatIndianAmount(totalDebit),
          styles: {
            halign: "right",
            fontStyle: "bold",
            fillColor: [220, 220, 220],
          },
        },
        {
          content: formatIndianAmount(totalCredit),
          styles: {
            halign: "right",
            fontStyle: "bold",
            fillColor: [220, 220, 220],
          },
        },
        {
          content: formatIndianAmount(opening),
          styles: {
            halign: "right",
            fontStyle: "bold",
            fillColor: [220, 220, 220],
          },
        },
      ]);

      const columnWidths = [15, 30, 30, 30, 40, 30, 30, 30];
      const totalWidth = columnWidths.reduce((a, b) => a + b, 0);
      const marginX = (pageWidth - totalWidth) / 2;

      autoTable(doc, {
        startY: yPos + 2,
        head: [
          [
            "Sr. No.",
            "Date",
            "Vou No",
            "Chq No",
            "Description",
            "Debit",
            "Credit",
            "Bal Type",
          ],
        ],
        body: tableRows,
        theme: "grid",
        styles: {
          fontSize: 9,
          valign: "middle",
          halign: "center",
          textColor: [0, 0, 0],
          cellPadding: { top: 0.5, bottom: 0.5, left: 2, right: 2 },
          minCellHeight: 8,
        },
        headStyles: {
          fillColor: [220, 220, 220],
          fontSize: 10,
          halign: "center",
          valign: "middle",
          fontStyle: "bold",
          textColor: 0,
          cellPadding: { top: 2, bottom: 2 },
        },
        columnStyles: {
          0: { cellWidth: columnWidths[0], halign: "center" },
          1: { cellWidth: columnWidths[1], halign: "center" },
          2: { cellWidth: columnWidths[2], halign: "center" },
          3: { cellWidth: columnWidths[3], halign: "center" },
          4: { cellWidth: columnWidths[4], halign: "left" },
          5: { cellWidth: columnWidths[5], halign: "right" },
          6: { cellWidth: columnWidths[6], halign: "right" },
          7: { cellWidth: columnWidths[7], halign: "right" },
        },
        tableWidth: totalWidth,
        margin: { left: marginX, right: marginX },
        didDrawPage: (data) => {
          yPos = data.cursor.y + 12;
        },
      });

      yPos += 8;
    });

    doc.save("Ledger_MultiYear_Report.pdf");
  };

  if (accountName.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
          fontSize: "20px",
          color:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour10,
        }}
      >
        Please Select Accounts Name
      </div>
    );
  }

  if (LedgerMultiYeardata === "no" || LedgerMultiYeardata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ paddingTop: "16px" }}>
      <style>{`
        .common-hover-btn {
          transition: transform 0.25s ease;
        }
        .common-hover-btn:hover {
          transform: scale(1.01);
        }
        .common-hover-btn:active {
          transform: scale(0.98);
        }
      `}</style>

      <Row>
        {/* HEADER CARD */}

        <Col xs={12}>
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              borderRadius: "16px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              padding: "24px",
              border: `2px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7}`,
            }}
          >
            <Row className="g-4 align-items-stretch">
              {/* LEFT CONTENT */}
              <Col xl={6} lg={6} md={12}>
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Row className="g-3">
                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            A/c Name:
                          </span>
                          <span
                            style={{
                              fontSize: "18px",
                              fontWeight: "800",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerMultiYeardata?.AccountDetail?.[0]?.AcName ||
                              ""}
                          </span>
                        </div>
                      </Col>

                      <Col md={6} xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Pan No:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerMultiYeardata?.AccountDetail?.[0]?.PanNo ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            City:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerMultiYeardata?.AccountDetail?.[0]
                              ?.CityName || "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-start",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.6",
                            }}
                          >
                            Address:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "1.6",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                            }}
                          >
                            {LedgerMultiYeardata?.AccountDetail?.[0]?.Address ||
                              "-"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-end",
                    }}
                  >
                    <button
                      onClick={handleDownload}
                      className="common-hover-btn"
                      style={{
                        background:
                          isdark === "light"
                            ? iscolour?.Colour6
                            : iscolourDark?.Colour10,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour4,
                        border: "none",
                        borderRadius: "10px",
                        padding: "12px 18px",
                        fontWeight: "700",
                        fontSize: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <FiDownload size={16} />
                      Download PDF
                    </button>
                  </div>
                </div>
              </Col>

              {/* RIGHT SIDE */}
              <Col xl={6} lg={6} md={12}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    gap: "12px",
                  }}
                >
                  {/* BOX 1 */}
                  <div
                    className="common-hover-btn"
                    style={{
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour2,
                      border: `1px solid ${
                        isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour10
                      }`,
                      borderLeft: `6px solid ${
                        isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour10
                      }`,
                      borderRadius: "12px",
                      width: "100%",
                      padding: "25px",
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          minWidth: "95px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour12,
                          letterSpacing: "2px",
                        }}
                      >
                        OPENING :
                      </span>

                      <span
                        style={{
                          fontSize: "28px",
                          fontWeight: "800",
                          textAlign: "center",
                          flex: 1,
                          color:
                            isdark === "light"
                              ? iscolour?.Colour12
                              : iscolourDark?.Colour12,
                          lineHeight: "1",
                        }}
                      >
                        {formatIndianAmount(selectedOpening || 0)}
                      </span>

                      <div style={{ minWidth: "95px" }}></div>
                    </div>
                  </div>

                  {/* BOX 2 */}
                  <div
                    className="common-hover-btn"
                    style={{
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour2,
                      border: `1px solid ${
                        isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour10
                      }`,
                      borderLeft: `6px solid ${
                        isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour10
                      }`,
                      borderRadius: "12px",
                      width: "100%",
                      padding: "25px",
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          minWidth: "95px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour12,
                          letterSpacing: "2px",
                        }}
                      >
                        BALANCE :
                      </span>

                      <span
                        style={{
                          fontSize: "26px",
                          fontWeight: "800",
                          textAlign: "center",
                          flex: 1,
                          color:
                            isdark === "light"
                              ? iscolour?.Colour12
                              : iscolourDark?.Colour12,
                          lineHeight: "1.2",
                        }}
                      >
                        {formatIndianAmount(selectedBalance || 0)}
                      </span>

                      <div style={{ minWidth: "95px" }}></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>

        <div style={{ marginBottom: "10px" }}>
          {years.length > 0 && (
            <div
              className="mt-4 overflow-x-auto pb-2"
              style={{ display: "flex", flexDirection: "row", gap: "10px" }}
            >
              {/* ALL Button */}
              <button
                onClick={() => setActiveYear("ALL")}
                className=" px-4 py-2 text-sm whitespace-nowrap transition "
                style={{
                  borderRadius: "8px",
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10} `,

                  backgroundColor:
                    activeYear === "ALL"
                      ? isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10
                      : isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,

                  color:
                    activeYear === "ALL"
                      ? isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1
                      : isdark === "light"
                        ? iscolour?.Colour11
                        : iscolourDark?.Colour9,
                }}
              >
                ALL
              </button>

              {years.map((year) => (
                <button
                  key={year}
                  onClick={() => setActiveYear(year)}
                  className=" px-4 py-2 rounded-t-lg text-sm whitespace-nowrap transition "
                  style={{
                    borderRadius: "8px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10} `,
                    backgroundColor:
                      activeYear === year
                        ? isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                        : isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour3,

                    color:
                      activeYear === year
                        ? isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1
                        : isdark === "light"
                          ? iscolour?.Colour11
                          : iscolourDark?.Colour9,
                  }}
                >
                  {year}
                </button>
              ))}
            </div>
          )}
        </div>

        <Col xs={12}>
          {tableData?.length > 0 && (
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  padding: "18px 22px",
                  margin: 0,
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    wordBreak: "break-word",
                  }}
                >
                  Year : {activeYear}
                </h2>
              </div>

              <FASTable
                data={tableData}
                columns={getColumns}
                externalTotals={externalTotals}
              />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}
